import * as React from "react";
import { withNamespaces, WithNamespaces } from "react-i18next";
import { updatePassword } from "src/api/user";
import { Profil } from "src/redux/user";
import { toast } from "react-toastify";

interface Props {
  profil: Profil;
}
interface State {
  oldPassword: string;
  newPassword: string;
  newPasswordValidation: string;
}
type PropsWithNamespaces = Props & WithNamespaces;
class UserAccount extends React.Component<PropsWithNamespaces, State> {
  state: State = {
    oldPassword: "",
    newPassword: "",
    newPasswordValidation: ""
  };
  onChangeOldPassword = e => {
    this.setState({
      oldPassword: e.target.value
    });
  };
  onChangeNewPassword = e => {
    this.setState({
      newPassword: e.target.value
    });
  };
  onChangeNewPasswordValidation = e => {
    this.setState({
      newPasswordValidation: e.target.value
    });
  };
  changePassword = async () => {
    try {
      await updatePassword(
        this.props.profil.id,
        this.state.oldPassword,
        this.state.newPassword
      );
      toast.success(this.props.t("user.account.success"));
    } catch {
      toast.error(this.props.t("user.account.error"));
    }
  };
  render() {
    return (
      <div className="custom-form">
        <p>{this.props.t("user.account.password")}</p>
        <div className="group">
          <input
            type="password"
            onChange={this.onChangeOldPassword}
            placeholder={this.props.t("user.account.password")}
          />
          <span className="highlight" />
          <span className="bar" />
          <label />
        </div>
        <p>{this.props.t("user.account.newPassword")}</p>
        <div className="group">
          <input
            type="password"
            onChange={this.onChangeNewPassword}
            placeholder={this.props.t("user.account.newPassword")}
          />
          <span className="highlight" />
          <span className="bar" />
          <label />
        </div>
        <p>{this.props.t("user.account.confirmNewPassword")}</p>
        <div className="group">
          <input
            type="password"
            onChange={this.onChangeNewPasswordValidation}
            placeholder={this.props.t("user.account.confirmNewPassword")}
          />
          <span className="highlight" />
          <span className="bar" />
          <label />
        </div>
        <div className="text-right">
          <button
            onClick={this.changePassword}
            disabled={
              !(
                this.state.oldPassword &&
                this.state.newPassword &&
                this.state.newPasswordValidation &&
                this.state.newPassword === this.state.newPasswordValidation
              )
            }
            className="btn btn-primary"
          >
            {this.props.t("user.account.button")}
          </button>
        </div>
      </div>
    );
  }
}

export default withNamespaces()(UserAccount);



// WEBPACK FOOTER //
// ./src/components/UserAccount.tsx